export const alerts = {
  alert_title_text: 'Alert',
  checkout_not_redeemable_text:
    'One or more items in the basket could not be paid for using this payment type. Please complete the transaction using another payment type.',
  seating_location_not_available_text: 'Your seating location is not available, please contact a member of staff.',
  table_not_available_text: 'Your table is not available, please contact the member of staff.',
  we_are_closed_text: 'Sorry, We are closed! please try later.',
  store_has_been_text: 'The Store has been closed',
  timeslot_has_expired_text: 'Timeslot has expired please select a new one.',
  remove_all_vouchers_text: 'Are you sure you wish to remove all vouchers from the basket?',
  choose_for_delivery_text: 'Please choose if the order is for delivery or collection first.',
  choose_location_text: 'Please choose location first.',
  choose_table_text: 'Please choose table first.',
};
